import { useState } from 'react'
import { appDownloadApi } from '../../api/endpoints'
import { Header } from './Header'
import { Footer } from './Footer'
import { CookieBanner } from './CookieBanner'
import { css } from './css'

export function BaixarAppPage() {
  const [erro, setErro] = useState<string | null>(null)
  const [baixando, setBaixando] = useState(false)

  async function baixarAndroid() {
    setErro(null)
    setBaixando(true)
    try {
      const { url } = await appDownloadApi.gerarLinkApk()
      window.location.href = url
    } catch (e) {
      setErro((e as Error).message || 'Não foi possível gerar o link agora. Tente de novo em instantes.')
    } finally {
      setBaixando(false)
    }
  }

  return (
    <div style={css('width: 100%; min-height: 100vh; background: #0B1220; display: flex; flex-direction: column;')}>
      <Header atual="app" />

      <div style={css('max-width: 700px; margin: 0 auto; width: 100%; box-sizing: border-box; padding: 72px 32px 24px; text-align: center; display: flex; flex-direction: column; gap: 12px; align-items: center;')}>
        <span style={css('color: #F5A623; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 1px;')}>Aplicativo</span>
        <h1 style={css('margin: 0; color: #FFFFFF; font-size: 34px; font-weight: 800;')}>Leve o Walleon no bolso</h1>
        <p style={css('margin: 0; color: #A8B0C3; font-size: 15px; line-height: 1.6; max-width: 480px;')}>Mesma conta, sempre sincronizada com a versão web. Lance uma compra, confira o saldo ou receba um aviso de conta conectada, direto do celular.</p>
      </div>

      <div style={css('max-width: 700px; margin: 0 auto; width: 100%; box-sizing: border-box; padding: 24px 32px 40px; display: flex; flex-direction: column; gap: 16px;')}>
        <div style={css('background: #131B2C; border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 32px; display: flex; flex-direction: column; gap: 18px; align-items: center; text-align: center;')}>
          <div style={css('width: 56px; height: 56px; border-radius: 14px; background: rgba(245,166,35,0.12); display: flex; align-items: center; justify-content: center; color: #F5A623;')}>
            <svg viewBox="0 0 24 24" width={28} height={28} fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
              <rect x={7} y={2} width={10} height={20} rx={2} /><path d="M11 18h2" />
            </svg>
          </div>
          <div>
            <div style={css('color: #FFFFFF; font-size: 18px; font-weight: 800; margin-bottom: 6px;')}>Android</div>
            <div style={css('color: #A8B0C3; font-size: 13.5px; line-height: 1.6; max-width: 420px;')}>
              Baixe o instalador (APK) direto do nosso servidor. Como ele não vem da Play Store, o Android vai pedir pra você confirmar a instalação de "fontes desconhecidas" — é esperado.
            </div>
          </div>
          <button
            onClick={baixarAndroid}
            disabled={baixando}
            style={css(`background: #F5A623; border: none; color: #0B1220; font-weight: 700; font-size: 15px; padding: 14px 32px; border-radius: 10px; cursor: pointer; opacity: ${baixando ? 0.7 : 1};`)}
          >
            {baixando ? 'Gerando link...' : 'Baixar para Android'}
          </button>
          {erro && <p style={css('margin: 0; color: #E96A6A; font-size: 13px;')}>{erro}</p>}
        </div>

        <div style={css('background: #131B2C; border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 32px; display: flex; flex-direction: column; gap: 12px; align-items: center; text-align: center; opacity: 0.7;')}>
          <div style={css('width: 56px; height: 56px; border-radius: 14px; background: rgba(255,255,255,0.06); display: flex; align-items: center; justify-content: center; color: #8892A8;')}>
            <svg viewBox="0 0 24 24" width={28} height={28} fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
              <rect x={7} y={2} width={10} height={20} rx={2} /><path d="M11 18h2" />
            </svg>
          </div>
          <div style={css('color: #FFFFFF; font-size: 18px; font-weight: 800;')}>iOS</div>
          <div style={css('color: #8892A8; font-size: 13.5px;')}>Em breve na App Store. Por enquanto, use a versão web em qualquer navegador.</div>
        </div>
      </div>

      <Footer />
      <CookieBanner />
    </div>
  )
}
